import { useLocation } from '@reach/router';
import gsap from 'gsap';
import React, {
  FunctionComponent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import useMobileViewportFix from '../hooks/use-mobile-viewport-fix';
import Header from './header';
import './layout.css';
import Loader from './loader';

const Layout: FunctionComponent = ({ children }) => {
  useMobileViewportFix();

  const location = useLocation();
  const loaderRef = useRef<HTMLDivElement>(null);
  const [showLoader, setShowLoader] = useState(location.pathname === '/');

  const hideLoader = useCallback(() => {
    if (!showLoader) {
      return;
    }

    setTimeout(() => {
      gsap
        .to(loaderRef.current, {
          autoAlpha: 0,
          duration: 0.8,
          ease: 'expo.inOut',
        })
        .then(() => {
          setShowLoader(false);
        });

      gsap.set('.header', {
        autoAlpha: 0,
      });

      gsap.to('.header', {
        autoAlpha: 1,
        duration: 1.8,
        delay: 2.2,
        ease: 'expo.inOut',
      });
    }, 500);
  }, [showLoader]);

  useEffect(() => {
    document.addEventListener('homePageMediasLoaded', hideLoader);

    return () =>
      document.removeEventListener('homePageMediasLoaded', hideLoader);
  }, [hideLoader]);

  return (
    <>
      {showLoader && <Loader ref={loaderRef} />}
      <Header />
      {children}
    </>
  );
};

export default Layout;
